var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 11.8125C13.5 13.1125 13.0437 14.2187 12.1312 15.1312C11.2187 16.0437 10.1125 16.5 8.8125 16.5C7.5125 16.5 6.40625 16.0437 5.49375 15.1312C4.58125 14.2187 4.125 13.1125 4.125 11.8125V4.875C4.125 3.9375 4.45325 3.14075 5.10975 2.48475C5.76625 1.82875 6.563 1.5005 7.5 1.5C8.437 1.4995 9.234 1.82775 9.891 2.48475C10.548 3.14175 10.876 3.9385 10.875 4.875V11.4375C10.875 12.0125 10.675 12.5 10.275 12.9C9.875 13.3 9.3875 13.5 8.8125 13.5C8.2375 13.5 7.75 13.3 7.35 12.9C6.95 12.5 6.75 12.0125 6.75 11.4375V4.5H8.25V11.4375C8.25 11.6 8.30325 11.7345 8.40975 11.841C8.51625 11.9475 8.6505 12.0005 8.8125 12C8.9745 11.9995 9.109 11.9463 9.216 11.8403C9.323 11.7343 9.376 11.6 9.375 11.4375V4.875C9.3625 4.35 9.17825 3.90625 8.82225 3.54375C8.46625 3.18125 8.0255 3 7.5 3C6.9745 3 6.53075 3.18125 6.16875 3.54375C5.80675 3.90625 5.6255 4.35 5.625 4.875V11.8125C5.6125 12.7 5.91875 13.4532 6.54375 14.0723C7.16875 14.6913 7.925 15.0005 8.8125 15C9.6875 15 10.4313 14.6908 11.0438 14.0723C11.6563 13.4538 11.975 12.7005 12 11.8125V4.5H13.5V11.8125Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/attachmentIcon.92a8cd704aa686142838d472c9fdb638.svg";
export { ForwardRef as ReactComponent };